package nl.volleyplanner.web.base.component

import kotlinx.coroutines.*
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.html.*
import kotlinx.html.js.nav
import nl.volleyplanner.web.CoroutineManager
import nl.volleyplanner.web.base.*
import nl.volleyplanner.web.base.routing.PageRouteContext
import org.w3c.dom.HTMLElement

data class BreadcrumbItemData(
    val pageMeta: PageMeta? = null,
    val fullPath: String? = null
)

class BreadcrumbItem(val page: WebPageController, val isActive: Boolean, val breadcrumbItemDataFlow: StateFlow<BreadcrumbItemData>) : HTMLComponent() {
    val pageMeta: PageMeta?
        get() = breadcrumbItemDataFlow.value.pageMeta
    val fullPath: String?
        get() = breadcrumbItemDataFlow.value.fullPath

    override fun render(consumer: TagConsumer<HTMLElement>): HTMLElement {
        return consumer.li (classes = "breadcrumb-item") {
            if (isActive) {
                classes += setOf("active fw-bold")
                attributes["aria-current"] = "page"

                if (pageMeta != null) {
                    +pageMeta!!.title
                } else {
                    spinner()
                }
            } else {
                if (pageMeta != null && fullPath != null) {
                    a (href = fullPath) {
                        +pageMeta!!.title
                    }
                } else {
                    spinner()
                }
            }
        }
    }

    override suspend fun getState() = breadcrumbItemDataFlow

}

class BreadcrumbComponent(val pageTree: List<WebPageController>, val pageContext: PageRouteContext) : HTMLComponent() {
    val pageControllerFlows = pageTree.associateWith { MutableStateFlow(BreadcrumbItemData()) }
    val pageTreeDependencyMap = pageTree.mapIndexed { index, controller ->
        Pair(controller, pageTree.subList(0, index))
    }.toMap()

    val coroutineJobs = mutableListOf<Job>()

    init {
        val coroutineScope = CoroutineManager.RENDER_SCOPE
        val pageMetaByController = pageTree.associateWith { controller ->
            controller.getPageMeta(coroutineScope, pageContext)
        }
        pageTree.forEach { controller ->
             val job = coroutineScope.launch {
                 val controllerPageMeta = pageMetaByController.getValue(controller).await()
                 val dependencies = pageTreeDependencyMap.getValue(controller)
                 val pageMetas = dependencies.map { pageMetaByController.getValue(it).await() } + controllerPageMeta
                 val fullPath = pageMetas.map { it.url }.joinToString("")
                     .ifBlank { "/" }      // For root page
                 val stateFlow = pageControllerFlows.getValue(controller)
                 stateFlow.value = stateFlow.value.copy(pageMeta = controllerPageMeta, fullPath = fullPath)
             }
            coroutineJobs.add(job)
        }
    }

    override fun onDispose() {
        super.onDispose()
        coroutineJobs.forEach { it.cancel() }
    }

    override fun render(consumer: TagConsumer<HTMLElement>): HTMLElement {
        return consumer.nav (classes = "bg-body-secondary rounded-3 px-3 mb-3") {
            attributes["aria-label"] = "breadcrumb"
            ol (classes = "breadcrumb py-2") {
                pageTree.forEachIndexed { index, pageController ->
                    component(BreadcrumbItem(pageController, index == pageTree.size - 1, pageControllerFlows.getValue(pageController)))
                }
            }
        }
    }

    override suspend fun getState() = null
}